import { Component, Host, State, getAssetPath, h } from '@stencil/core';

@Component({
  tag: 'fast-help-fashion',
  styleUrl: 'fast-help-fashion.css',
  shadow: false,
})
export class FastHelpFashion {
  @State() name = '';
  @State() imagePath = '/assets/fast_help_blue.png';

  onNameChange(e) {
    let hiddenPersonalizationEl = document.querySelector('[name="personalization"]') as HTMLInputElement;
    this.name = e.target.value.toUpperCase();
    hiddenPersonalizationEl.value = this.name;
  }

  componentDidLoad() {
    const select = document.getElementById('pa_color') as HTMLInputElement;

    if (select) {
      select.addEventListener('change', () => {
        if (select.value === 'blue') {
          this.imagePath = '/assets/fast_help_blue.png';
        } else if (select.value === 'pink') {
          this.imagePath = '/assets/fast_help_pink.png';
        }
      });
    }
  }

  render() {
    return (
      <Host>
        <div>
          <div class="d-flex justify-content-center">
            <div class="image-container">
              <img src={getAssetPath(this.imagePath)} class="img-fluid" alt="Personalized Fast Help Pendant" />
              <p class="fast-help-fashion-name">{this.name}</p>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col d-flex justify-content-center">
              <div class="form-group w-75 mb-2">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  type="text"
                  class="form-control"
                  placeholder="Enter Your Name Here"
                  maxLength={8}
                  onInput={e => this.onNameChange(e)}
                  style={{
                    backgroundColor: 'white',
                    border: '1px solid grey',
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
